import constate from 'constate'
import { TFilter } from '../definitions'

const useFilter = ({ filterData }: { filterData: TFilter }) => ({
  filterData
})

export const [FilterProvider, useFilterContext] = constate(useFilter)
